import { NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule({
  imports: [MatIconModule],
})
export class IconModule {
  constructor(sanitizer: DomSanitizer, iconRegistry: MatIconRegistry) {
    console.log('icon module init');
  }
}
